import axios from 'axios';

const cep = axios.create({
  baseURL: 'https://viacep.com.br/ws/',
  timeout: 1000,
});

export default cep;
